import React, { useEffect, useState } from 'react';
import TextTemplateType from '../../enum/TextTemplateType';
import TextTemplate from '../../model/TextTemplate';
import { ServiceApi } from '../../service/ServiceApiWithLoading';
import { useAuthentication } from '../../reducer/authentication';
import DefaultButton from '../FormControl/DefaultButton';
import { WhereCondition } from '../../service/ServiceApi';
import Task from '../../model/Task';
import { text } from 'stream/consumers';

interface TextTemplateButtonsProps {
    onClick: (textTemplate: TextTemplate) => Promise<void>;
    type: TextTemplateType;
    style?: React.CSSProperties;
    disabled?: boolean;
    task?: Task;
    page: 'task' | 'taskInternal' | 'taskInternalProductEngineering' | 'taskInternalSupport';
}

const apiTextTemplate = new ServiceApi<TextTemplate>('textTemplate');

export default function TextTemplateButtons(props: TextTemplateButtonsProps) {
    const { onClick, type, style, disabled, task, page } = props;

    const { user } = useAuthentication();

    const [textTemplates, setTextTemplates] = useState<TextTemplate[]>([]);

    useEffect(() => {
        const where: WhereCondition<TextTemplate> = [['type', '=', type]];
        if(page === 'task') {
            where.push(['use_in_task', '=', true]);
        }
        if (page === 'taskInternal') {
            where.push(['use_in_task_internal', '=', true]);
        }
        if (page === 'taskInternalProductEngineering') {
            where.push(['use_in_task_product_engineering', '=', true]);
        }
        if (page === 'taskInternalSupport') {
            where.push(['use_in_task_internal_support', '=', true]);
        }
        apiTextTemplate.getList({ where, orWhere: [['user_id', '=', user?.id], ['is_private', '=', false]], order: { name: 'ASC' }, relations: ['assigned_to_users', 'system_attachments'] }).then(setTextTemplates);
    }, []);

    async function onClickButton(textTemplate: TextTemplate) {
        var template = textTemplate.template;
        if(task){
            if (task.ticket_code && template.includes('{codigo}')) {
                template = template.replace('{codigo}', task.ticket_code);
            }
            if (task.user?.name && template.includes('{atribuido}')) {
                template = template.replace('{atribuido}', task.user.name);
            }
            if (task.final_customer?.name && template.includes('{cliente}')) {
                template = template.replace('{cliente}', task.final_customer.name);
            }
            textTemplate.template = template;
        }
        await onClick(textTemplate);
    }

    return textTemplates.length > 0 ? <div style={{ ...style }}>
        {textTemplates.map((tp) =>
            <DefaultButton
                key={`template-button-${tp.id}`}
                onClick={() => onClickButton(tp)}
                style={{ marginRight: 4, marginBottom: 4 }}
                type={'button'}
                variant="contained"
                size='small'
                disabled={!!disabled}
            >
                {tp.name}
            </DefaultButton>
        )}
    </div> : null;
}